import { temAcesso } from '@/shared/auth/temAcesso'
const Etapas = () => import('./Etapas.vue')
const Etapa = () => import('./Etapa.vue')

export default [
    {
        path: 'etapas',
        name: 'Sgtec_Gestores_Etapas',
        component: Etapas,
        beforeEnter: (to, from, next) => {
            if (temAcesso('SGTEC-GEST-ETP-00')) {
                next()
            }
        }
    },
    {
        path: 'etapas/:etapaId',
        name: 'Sgtec_Gestores_Etapa_Detalhar',
        component: Etapa,
        beforeEnter: (to, from, next) => {
            if (temAcesso('SGTEC-GEST-ETP-01')) {
                next()
            }
        }
    }
]
